import React from 'react';
import { Col, Typography, Row as AntRow } from 'antd';
import styled, { ITheme } from 'styled-components';
import { ReactComponent as MultiChainSVG } from 'src/assets/svg/home/multi-chain-feature.svg';
import { ReactComponent as SelectedProjectSVG } from 'src/assets/svg/home/select-project-feature.svg';
import { ReactComponent as FairSquareSVG } from 'src/assets/svg/home/fair-square-feature.svg';

const { Text } = Typography;

const Section = styled.div`
    max-width: 1272px;
    margin: 0 auto;
    margin-top: 160px;

    .feature-project-fieldset {
        width: 100%;
        border: 0.5px solid ${({ theme }: { theme: ITheme }) => theme.green2};
        border-radius: 8px;
        .fieldset-title {
            width: 25%;
            color: ${({ theme }: { theme: ITheme }) => theme.white};
            margin-left: 100px;
            padding-left: 20px;
            .title-fea {
                font-family: 'Orbitron';
                font-style: normal;
                font-weight: 700;
                font-size: 52px;
                line-height: 66px;
                letter-spacing: 0.02em;
                color: ${({ theme }: { theme: ITheme }) => theme.text3};
            }
            .title-tures {
                color: ${({ theme }: { theme: ITheme }) => theme.white};
            }
        }
    }

    .list-features {
        margin-top: 40px;
        padding: 0px 60px;
        justify-content: space-between;
    }

    .feature-item {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        margin: auto;
        align-items: center;
        align-self: normal;
    }

    .feature-image {
        width: 218px;
        margin-bottom: 32px;
    }

    .feature-header {
        color: ${({ theme }: { theme: ITheme }) => theme.white};
    }

    .feature-content {
        margin: 16px 20px 16px;
        color: ${({ theme }: { theme: ITheme }) => theme.white};
        letter-spacing: 0.02em;
        text-align: center;
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        padding: 0 10px;
        max-width: 100%;
        margin-top: 80px;
        .features ~ .features {
            margin-top: 24px;
            margin-left: 0px;
        }
        .feature-item {
            width: 100%;
        }
        .list-features {
            padding: 0px 20px;
        }
        .feature-project-fieldset {
            width: 100%;
            border: none;
            border-radius: none;
            .fieldset-title {
                margin-left: 0;
                padding-left: 0;
                text-align: center;
                .title-fea {
                    font-size: 22px;
                    line-height: 32px;
                    letter-spacing: 0.02em;
                }
            }
        }
        .feature-content {
            margin: 16px 0px 16px;
            color: ${theme.white};
            letter-spacing: 0.02em;
            text-align: center;
        }
    `}
`;

const features = [
    {
        svg: <MultiChainSVG />,
        title: 'Multi-Chain Support',
        content: 'Exposure to new project listing on the biggest networks, BSC. ERC 20, etc',
        viewMore: 'Multi - Chain',
        route: '/#multi-chain',
    },
    {
        svg: <SelectedProjectSVG />,
        title: 'Selected projects',
        content:
            'All of our listed projects will be hand-picked by our board of member, to make sure the project has disruptive unique selling points & real investing potential',
        viewMore: 'Hand-picked',
        route: '/#hand-picked',
    },
    {
        svg: <FairSquareSVG />,
        title: 'Fair & Square',
        content:
            'We understand that opportunities should be delivered fairly and efficiently. We ensure everybody has a chance to join accordingly based on their tier without gas war. Higher tier will have a chance to buy first.',
        viewMore: 'Fairness',
        route: '/#fairness',
    },
];

const FeatureItem = ({ feature }: any) => {
    return (
        <div className="feature-item" id={feature.router}>
            <div className="feature-image">{feature.svg}</div>
            <Text className="fs-supermedium fw-suppermedium feature-header">{feature.title}</Text>
            <Text className="feature-content fs-small fw-regular">{feature.content}</Text>
        </div>
    );
};

const FeaturesV2 = () => {
    return (
        <Section>
            <AntRow
                className="home-section"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="500"
            >
                <fieldset className="feature-project-fieldset">
                    <legend className="fieldset-title">
                        <span className="title-fea">Fea</span>
                        <span className="title-tures title-fea">tures</span>
                    </legend>
                    <AntRow className="list-features">
                        {features.map((feature, idx) => {
                            const key = idx + 1;
                            return (
                                <Col key={key} className="features" xs={24} lg={8}>
                                    <FeatureItem key={feature.route.substr(1)} feature={feature} />
                                </Col>
                            );
                        })}
                    </AntRow>
                </fieldset>
            </AntRow>
        </Section>
    );
};

export default FeaturesV2;
